































































































































































































import { multiply } from 'lodash';
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';

@Component({
})

export default class DeptRatioCalculator extends Vue {

    calculator: boolean = false;
    result: number = 0
    calcul: any = {
        isCo: false,
        people_in_home: undefined,
        revenue_home: 0,
        property_income_home: 0,
        personnal_contribution: 0,
        monthly_charges_home: 0,
        current_loan: 0,
        first: {
            monthly_income: 0,
            property_income: 0,
            monthly_charges: 0
        },
        co: {
            monthly_income: 0,
            property_income: 0,
            monthly_charges: 0
        },
        acquisition_price: 0,
        notary: 0,
        duration: 20,
        tx: 3.5,
        txError: false,

        amountToCredit: 0,
        mensual: 0,
        restToLive: 0,
        debtTx: 0
    }

    plafond: any = {
        A: 14.49,
        Abis: 14.49,
        B1: 11.68,
        B1D: 10.48,
        B2: 10.15
    }

    @Watch('calcul.tx', { deep: true })
    onTx() {
        if(this.calcul.tx > 6) {
            this.calcul.txError = true;
        } else {
            this.calcul.txError = false;
        }
    }


    handleTxInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = parseFloat(input.value);
    if (isNaN(value)) {
      value = 0;
    }
    this.calcul.tx = Math.min(Math.max(value, 0), 6);
  }


    @Watch('calcul', { deep: true })
    onCalcul() {
        let monthly_income_first = this.calcul.first.monthly_income > 0 ? parseInt(this.calcul.first.monthly_income) : 0;
        let monthly_income_co = this.calcul.co.monthly_income > 0 ? parseInt(this.calcul.co.monthly_income) : 0;
        this.calcul.revenue_home = monthly_income_first + monthly_income_co;

        let monthly_property_first = this.calcul.first.property_income > 0 ? parseInt(this.calcul.first.property_income) : 0;
        let monthly_property_co = this.calcul.co.property_income > 0 ? parseInt(this.calcul.co.property_income) : 0;
        this.calcul.property_income_home = monthly_property_first + monthly_property_co;

        let monthly_charges_first = this.calcul.first.monthly_charges > 0 ? parseInt(this.calcul.first.monthly_charges) : 0;
        let monthly_charges_co = this.calcul.co.monthly_charges > 0 ? parseInt(this.calcul.co.monthly_charges) : 0;
        this.calcul.monthly_charges_home = monthly_charges_first + monthly_charges_co;

        this.calcul.notary = this.calcul.acquisition_price ? this.calcul.acquisition_price * 0.025 : 0;

        let price = this.calcul.acquisition_price ? parseInt(this.calcul.acquisition_price) : 0;
        let apport = this.calcul.personnal_contribution ? parseInt(this.calcul.personnal_contribution) : 0;
        if(this.calcul.tx > 6) {
            return;
        }
        if(price > 0 && this.calcul.revenue_home > 0) {
            this.calcul.amountToCredit = price - apport;
            let txdiv = this.calcul.tx / 100;
            let tx = 1 + (txdiv / 12);
            let pow = - (12 * parseInt(this.calcul.duration));
            let mensuals = ((parseInt(this.calcul.amountToCredit) * txdiv) / 12) / (1 - Math.pow(tx, pow));
            this.calcul.mensual = Math.round(mensuals);
            this.calcul.restToLive = Math.round((this.calcul.revenue_home + (this.calcul.property_income_home * 0.7)) - (this.calcul.monthly_charges_home + parseInt(this.calcul.current_loan) + this.calcul.mensual));
            this.calcul.debtTx = Math.round(((this.calcul.monthly_charges_home + parseInt(this.calcul.current_loan) + this.calcul.mensual) * 100) / (this.calcul.revenue_home + (this.calcul.property_income_home * 0.7)));
        }
    }


    calculateRent() {
        for (var key in this.calcul) {
            if(!this.calcul[key] && key !== 'surface_terrace') {
                return
            }
        }
        let surface = parseInt(this.calcul.surface);
        let surface_terrace = parseInt(this.calcul.surface_terrace);
        let utilitySurface = surface + (surface_terrace >= 8 ? 8 : surface_terrace/2)
        if(this.calcul.geozone == 'B1D') {
            utilitySurface = surface + (surface_terrace >= 14 ? 14 : surface_terrace);
        }
        let multiply = 0.7 + (19/utilitySurface) > 1.2 ? 1.2 : 0.7 + (19/utilitySurface);
        if(this.plafond[this.calcul.geozone]) {
            let perMeter = this.plafond[this.calcul.geozone] * multiply;
            return this.result = Math.round(perMeter * utilitySurface);
        }


        return this.result = 0;
    }
}
